{
    "coordinates": [
        -33.002552753963904,
        18.999821383633076
    ],
    "tooltip": "Soom Shale",
    "title": "Cederberg Formation (Soom Shale)",
    "country": "South Africa",
    "period": "Ordovician",
    "alt": "TODO"
}
